import { Component, Inject } from '@angular/core';
import { MAT_LEGACY_DIALOG_DATA as MAT_DIALOG_DATA } from '@angular/material/legacy-dialog';

@Component({
  selector: 'ag-patron-expiry-msg-dialog',
  templateUrl: './patron-expiry-msg-dialog.component.html',
  styleUrls: ['./patron-expiry-msg-dialog.component.scss'],
})
export class PatronExpiryMsgDialog {
  name: string;
  expireDate: string;
  expireText: string;

  constructor(@Inject(MAT_DIALOG_DATA) private _userData: any) {
    if (_userData) {
      this.name = `${_userData.firstName} ${_userData.lastName}`;
      this.expireDate = _userData.expireDate;
      this.expireText = new Date(_userData.expireDate) < new Date() ? 'expired' : 'will expire';
    }
  }
}
